import { makeObservable, observable } from 'mobx'
import { LstItmBase } from '../base/lst-itm-base'

/**
 * Class representing a Request item, extending the base list item class LstItmBase.
 * Contains additional properties and methods specific to Request items.
 *
 * @class Request
 * @extends {LstItmBase}
 */
export class Request extends LstItmBase {
	_class = 'Request'
	request_id

	/**
	 * Creates an instance of Request.
	 * @param {string} id - The unique identifier for the Request item.
	 */
	constructor(id) {
		super(id)
		this.request_id = id

		makeObservable(this, {
			request_id: observable
		})
	}
}
